import { calculateAge } from './calcSurveyDerivatives';
import { zipCodeToState } from './zipCodeToState';

const MARITAL_STATUS_MAPPING: Record<string, string> = {
  'Never married': 'Single',
  'Married': 'Married',
  'Married, spouse absent': 'Married',
  'Partnered': 'Married',
  'Separated': 'Single',
  'Divorced': 'Single',
  'Widowed': 'Single',
  "I don't know / prefer not to answer": 'Single',
};

function mapMaritalStatusToTraditionalLTC(maritalStatus?: string): string {
  if (!maritalStatus) return 'Single';

  return MARITAL_STATUS_MAPPING[maritalStatus] || 'Single';
}

export function calcClientDemographics(intakeSurvey: Partial<IntakeSurvey>) {
  const dateOfBirth = intakeSurvey.clientBirthDate ? new Date(intakeSurvey.clientBirthDate) : null;
  const age = dateOfBirth ? calculateAge(dateOfBirth) : 0;
  const isTobacco = () =>
    intakeSurvey.clientSmokerEver === 'Yes' || intakeSurvey.clientSmokedRecently === 'Yes';

  const clientTobaccoStatus = isTobacco() ? 'Tobacco' : 'Non-Tobacco';
  const gender = intakeSurvey.clientGenderAtBirth === 'Male' ? 'Male' : 'Female';
  const state = intakeSurvey.clientZipCode ? zipCodeToState(intakeSurvey.clientZipCode) : null;

  const demographics = {
    primaryAge: age,
    primaryGender: gender,
    primaryTobaccoStatus: clientTobaccoStatus,
    state,
    maritalClass: intakeSurvey.clientMaritalStatus
      ? mapMaritalStatusToTraditionalLTC(intakeSurvey.clientMaritalStatus)
      : null,
  };

  return demographics;
}
